import React, { useState } from "react";
import ImportExportImg from "@assets/images/uniqueexporters&importers.svg";
import { tabHeadingDictionary as tabKeywords, timeFrameOptions, requestObjectTypeDictionary } from "@core/global/global-country-dictionary";
import Select from "react-select";
import { Card, Form } from "react-bootstrap";
import TabHeader from "@shared/country-components/tabHeader";
import ReactTooltip from "react-tooltip";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import { TrendsData } from "@shared/unique-importer-exporter-trends";
import { ChevronLeft, ChevronRight } from "react-feather";
import { searchTypeCustomStyles } from "@utils/utils";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import UpgradeIcon from "@assets/images/Solid_Status_Lightning-alt.svg";
import Table from "@shared/trademo-datatable/DataTable";
import { secondLevelRowsDropdown } from "@utils/enum";
import { LogisticsFilter } from "../components/InternalFilter/logisticsFilter";
import DynamicDropdown from "@components/base/DynamicDropDown/DynamicDropDown";

const Logistics = (props) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggle = (name) => setActiveDropdown(activeDropdown === name ? null : name);
  const close = () => setActiveDropdown(null);

  return (
    <div>
      <div className={props.currentTab === tabKeywords.logistics ? "tab-pane fade show active" : "tab-pane fade"} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
        <div className="trademo-table-container">
          {!!props.currentUserPlan && props.currentUserPlan !== "" && !!props.currentPlanAccess && props.currentPlanAccess.consignee_shipper === false ? (
            <Card className="upgrade-card">
              <Card.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-auto">
                      <div>
                        <img src={UpgradeIcon} alt="..." className="img-fluid" />
                      </div>
                    </div>
                    <div className="col">
                      <p>This feature enables you to view list of unique consignee across the searched shipments with standardised names and after exclusion of logisitic companies</p>
                      <p>Upgrade to higher Pro or Advanced plan to use this feature</p>
                      <div className="d-block my-3">
                        <button type="button" className="btn btn-success tw-bg-secondary-green" onClick={(e) => props.upgradeNow(e)}>
                          Upgrade
                        </button>
                      </div>
                      <div className="d-block">
                        <img src={ImportExportImg} alt="..." className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <div className="tw-flex tw-flex-col">
              <div className="tw-flex tw-flex-col tw-gap-4 tw-py-4">
                <div className="tw-flex tw-w-full tw-justify-start tw-h-9">
                  {!!props.showUiTrends && props.showUiTrends === true ? (
                    <div className="col-md-4 d-flex tw-px-0">
                      <div className="tw-flex tw-border tw-border-gray-200 tw-rounded-lg">
                        <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4 ${props.logisticsTrendsTab === false && props.isLogisticsTableVisible === true ? "tw-bg-gray-200 tw-font-semibold tw-rounded-l" : "non-selected"}`} onClick={() => props.setLogisticsTrendsToggle(false)}>
                          Rank
                        </span>
                        <span className={`cursor-pointer tw-text-sm tw-text-gray-900 tw-font-medium tw-py-2 tw-px-4 ${props.logisticsTrendsTab === true ? "tw-bg-gray-200 tw-font-semibold tw-rounded-r" : "non-selected"}`} onClick={() => props.setLogisticsTrendsToggle(true)}>
                          Trends
                        </span>
                      </div>
                      {props.isLogisticsTableVisible !== false && props.logisticsTrendsTab ? (
                        <div className="sort-dropdown d-flex ml-2 modifying-styling">
                          <div className="custom-dropdown d-flex justify-content-center align-items-center">
                            <Select
                              isSearchable={false}
                              options={timeFrameOptions}
                              defaultValue={props.currentLogisticsFrame}
                              styles={searchTypeCustomStyles}
                              onChange={(e) => {
                                if (e && e.value && e.value === "year") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsYoY);
                                } else if (e && e.value && e.value === "month") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsMoM);
                                } else if (e && e.value && e.value === "quarter") {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsQoQ);
                                }
                                props.changeUniqueLogisticsDuration(e);
                              }}
                              className="match-type my-auto mx-0 w-100 tw-z-[3]"
                              autosize={true}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {props.isLogisticsTableVisible === false || props.logisticsTrendsTab === true || props.defaultData.showUiUeLevelTwo ? (
                    <div className="col-md-4 d-flex justify-content-center tw-px-0">
                      {props.defaultData.showUiUeLevelTwo && !(props.isLogisticsTableVisible === false && props.logisticsTrendsTab === false) && !props.isMerged ? (
                        <div id="second-level-toggle" className="d-flex align-items-center justify-content-end ml-2">
                          <span className="mr-1 two_level_label">Enable 2nd Level Hierarchy</span>
                          <span className={props.defaultData.showUiUeLevelTwo && props.ulTwoLevel ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                            <Form.Check
                              type="switch"
                              id="custom-switch-1"
                              checked={props.ulTwoLevel}
                              onChange={(e) => {
                                if (props.logisticsTrendsTab && e.target.checked) {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends2ndLevelAnalytics);
                                } else if (e.target.checked) {
                                  props.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank2ndLevelAnalytics);
                                }
                                props.changeULTwoLevelHandler(e);
                              }}
                            />
                          </span>
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="tw-w-full">
                  <div className="tw-flex tw-justify-between">
                    <div>
                      <TabHeader
                        addToFaV={props.addToFaV}
                        setAddToFav={(val) => props.setAddtoFav(val)}
                        getUserPlan={() => props.getUserPlanHandler()}
                        applyUIUEFilterHandler={props.applyUIUEFilterHandler}
                        prospectData={props.prospectLogistics}
                        type="Logistics"
                        userFirstPlan={props.userFirstPlan}
                        selectedData={props.selectedLogisticsRowData}
                        upgradePlansDictionary={props.upgradePlansDictionary}
                        userCredit={props.userCredit}
                        creditQuota={props.creditQuota}
                        totalDataCount={props.totalUniqueLogistics}
                        defaultData={props.defaultData}
                        onDownload={(type, downloadFromValue, downloadToValue, closeDownloadFromModal) => props.downloadImpExpConfirm(type, downloadFromValue, downloadToValue, closeDownloadFromModal)}
                        onSelect={(closeDownloadFromModal) => props.mappingUniqueImporterExporter("XLS", "Logistics", closeDownloadFromModal)}
                        tradeDirection={props.defaultData.countryType}
                        dataSource={props.defaultData.country_small}
                        isSalesForceRedirection={props.isSalesForceRedirection}
                        currentUserPlan={props.currentUserPlan}
                        pathname={window.location.pathname}
                        showBolFilter={props.showBolFilter}
                        analyticsCountryID={props.defaultData.analyticsCountryID}
                        isRedirect={props.isRedirect}
                        redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                        redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                        clearButton={() => props.clearButton}
                        trendsTab={props.trendsTab || props.exporterTrendsTab || props.logisticsTrendsTab}
                        onClear={() => props.toggleClearButton("logistics")}
                        isTwoLevel={props.ulTwoLevel}
                        isMerged={props.isMerged}
                        redirectionCompanyType={props.redirectionCompanyType}
                        currentTab={props.currentTab}
                      />
                    </div>
                    <div className="tw-flex tw-gap-2">
                      <div>{props.currentPlanAccess && props.currentPlanAccess.is_internal_filter !== false ? <LogisticsFilter sendingDataToSearch={(data) => props.gettingDataFromUIEFilter(data)} /> : <></>}</div>
                      {props.ulTwoLevel && (
                        <DynamicDropdown
                          isOpen={activeDropdown === "secondLevel"}
                          dropdownValue={activeDropdown}
                          onToggle={() => toggle("secondLevel")}
                          onClose={close}
                          buttonLabel={`No. of 2nd Level Entities : ${props.secondLevelRowDropdownValue.label}`}
                          options={secondLevelRowsDropdown}
                          onSelect={(item) => {
                            props.onSecondLevelLogisticsRowDropdownChange(item);
                            close();
                          }}
                          icon={{ after: true, before: false, onClose: "keyboard_arrow_down", onOpen: "keyboard_arrow_up" }}
                          buttonId="second-level-dropdown"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {props.isLogisticsTableVisible === true && props.logisticsTrendsTab === false ? (
                <div className={`${props.defaultData.showUiUeLevelTwo && props.ulTwoLevel ? "lvl-two-table-container lvl-two-i-e-l lvl-two-common-table" : ""}  tw-border tw-rounded-lg`}>
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                  {props.isUIGridNew && props.isUIGridNew === true && !props.ulTwoLevel ? (
                    <ReactTableTrademo
                      columns={props.logisticsTableColumn}
                      data={props.defaultTrendsData}
                      paginationTotalRows={props.totalUniqueLogistics}
                      onSelectedRowsChange={(selectedRows) => {
                        props.selectedLogisticsRowFun(selectedRows);
                      }}
                      onSort={(e) => props.handleLogisticsSortingClone(e, props.logisticsSortOrderValue === "desc" ? "asc" : "desc")}
                      defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.logisticsSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.logisticsSortValue] : props.logisticsDefaultSortValue ? props.logisticsDefaultSortValue.columnKey : "date"}
                      defaultSortAsc={props.logisticsSortOrderValue === "desc" ? false : true}
                      paginationPerPage={props.logisticsPerPage}
                      onChangeRowsPerPage={props.handleSearchPerRowsLogisticsChangeClone}
                      onTableObjectChange={props.updateTrademoULTableObjectClone}
                      onChangePage={props.handlePerRowsChangeLogisticsClone}
                      paginationDefaultPage={props.logisticsCurrentPage}
                      noDataComponent={props.isLoaderActive === true || props.isDownloadLoaderActive === true || props.isTrendsActive ? "" : "No Unique Logistics Found"}
                      clearSelectedRows={props.logisticsToggleRows}
                      selectedData={props.selectedLogisticsRowData}
                      shipmentDefaultSortValue={props.defaultData.logisticsSorting}
                      sortOrderValue={props.logisticsSortOrderValue}
                      hideSorting={true}
                      fixSelection="start"
                      options={[25, 50, 100]}
                    />
                  ) : props?.secondLevelData?.length ? (
                    <Table
                      currentTab={props.currentTab}
                      defaultTrendsData={props.logisticsTrendsTab}
                      columns={props.logisticsTableColumn}
                      data={!!props.defaultTrendsData && props.defaultTrendsData.length !== 0 && props.ulTwoLevel === false ? props.defaultTrendsData : props?.secondLevelData?.length ? props.secondLevelData : []}
                      paginationTotalRows={props.totalUniqueLogistics}
                      onSelectedRowsChange={(selectedRows) => props.selectedLogisticsRowFun(selectedRows)}
                      onSort={(e) => props.handleLogisticsSortingClone(e, props.logisticsSortOrderValue === "desc" ? "asc" : "desc")}
                      defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.logisticsSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.logisticsSortValue] : props.logisticsDefaultSortValue ? props.logisticsDefaultSortValue.columnKey : "date"}
                      defaultSortAsc={props.logisticsSortOrderValue === "desc" ? false : true}
                      paginationPerPage={props.logisticsPerPage}
                      onChangeRowsPerPage={props.handleSearchPerRowsLogisticsChange}
                      onChangePage={props.handlePerRowsChangeLogistics}
                      selectedData={props.selectedLogisticsRowData}
                      paginationDefaultPage={props.logisticsCurrentPage}
                      clearSelectedRows={props.logisticsToggleRows}
                      noDataComponent={props.isLoaderActive ? "" : "No Unique Logistics Found"}
                      showTwoLevel={props.ulTwoLevel}
                      viewAllPerPage={props.viewAllPerPage}
                      defaultPage={props.defaultPage}
                      secondLevelRowDropdownValue={props.secondLevelRowDropdownValue.value}
                      paginationIconPrevious={
                        <ChevronLeft
                          color={props.defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                          onClick={() => {
                            props.prevSecondLevelHandler();
                          }}
                        />
                      }
                      paginationIconNext={
                        <ChevronRight
                          color={"rgba(0,0,0,0.54)"}
                          onClick={() => {
                            props.nextSecondLevelHandler();
                          }}
                        />
                      }
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : props.logisticsTrendsTab === true ? (
                <div>
                  <TrendsData
                    isTrendsTab={props.currentTab === tabKeywords.logistics ? props.logisticsTrendsTab : this.state.currentTab === tabKeywords.exporters ? this.props.exporterTrendsTab : this.props.trendsTab}
                    isTwoLevel={props.currentTab === tabKeywords.logistics ? props.ulTwoLevel : this.state.currentTab === tabKeywords.exporters ? this.props.ueTwoLevel : this.props.uiTwoLevel}
                    dynamicTrendsData={props.dynamicTrendsData}
                    handleChangePerPage={(e) => {
                      props.ULHandlerPerPage(e);
                    }}
                    showPopup={props.showPopup}
                    setShowPopup={(val) => props.setShowPopUp(val)}
                    applyUIUEFilterHandler={props.applyUIUEFilterHandler}
                    filterObj={props.filterObj}
                    currentUserPlan={props.currentUserPlan}
                    pathname={window.location.pathname}
                    analyticsCountryID={props.defaultData.analyticsCountryID}
                    analyticsTrends_mustnot_Data={props.analyticsTrends_mustnot_Data}
                    defaultTrendsData={!!props.defaultTrendsData && props?.defaultTrendsData?.length !== 0 && props.ulTwoLevel === false ? props.defaultTrendsData : props?.secondLevelData?.length ? props.secondLevelData : []}
                    paginationDefaultPage={props.logisticsCurrentPage}
                    clearButton={props.clearButtonState}
                    selectedRows={props.prospectLogistics}
                    paginationTotalRows={props.totalUniqueLogistics}
                    totalCompanyCount={props.totalUniqueLogistics}
                    defaultUlTwoLevelSelectedHeading={props.defaultUlTwoLevelSelectedHeading}
                    isNewShow={props.isUIGridNew}
                    onSelectedRowsChange={(selectedRows) => props.selectedLogisticsRowFunClone(selectedRows)}
                    onTableObjectChange={props.updateTrademoULTableObjectClone}
                    selectedData={props.selectedLogisticsRowData}
                    sortType={props.logisticsSortValue}
                    currentTab={props.currentTab}
                    requestObj={props.existingSearchReqObj}
                    currentKeyViewTrendItem={props.finalReqObj}
                    timeFrame={props.currentLogisticsFrame}
                    clearSelectedRows={props.logisticsToggleRows}
                    viewTrends={() => props.getUniqueLogisticsData(requestObjectTypeDictionary.logistics, "pagination")}
                    handleTrendsSorting={(data1, data2) => props.handleTrendsSorting(data1, data2)}
                    defaultSortAsc={props.logisticsSortOrderValue === "desc" ? false : true}
                    paginationPerPage={props.logisticsPerPage}
                    onChangeRowsPerPage={props.handleSearchPerRowsLogisticsChangeClone}
                    defaultSort={props.logisticsDefaultSort}
                    sortOrderValue={props.logisticsSortOrderValue}
                    onChangePage={props.handlePerRowsChangeLogistics}
                    currentPlanAccess={props.currentPlanAccess}
                    isLoaderActive={props.isLoaderActive || props.isDownloadLoaderActive === true || props.isTrendsActive}
                    selectSortDefaltValueHandler={props.selectSortDefaltValueHandler(props.logisticsSortValue)}
                    isSalesForceRedirection={props.isSalesForceRedirection}
                    defaultData={props.defaultData}
                    isRedirect={props.isRedirect}
                    redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                    redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                    twoColumnMapping={props.defaultData.twoColumnMapping}
                    defaultUiUeTwoLevelSelctedHeading={props.defaultUiUeTwoLevelSelctedHeading}
                    selectedUiUeTwoLevelHeading={(data) => props.selectedUiUeTwoLevelHeading(data)}
                    selectedUlTwoLevelHeading={(data) => props.selectedUlTwoLevelHeading(data)}
                    showTwoLevel={props.ulTwoLevel}
                    viewAllPerPage={props.logisticsPerPage}
                    defaultPage={props.defaultPage}
                    viewTrendsFinalSearchReqObj={props.finalReqObj}
                    updatingMustNot={(data) => {
                      props.updatingMustNot(data);
                    }}
                    isGridNew={props.isUIGridNew}
                    fixedLengthUpto={props.fixedLengthUptoTrend}
                    resetSecondLevel={() => props.resetSecondLevel}
                    trendsTab={props.trendsTab}
                    handleIESorting={props.logisticsSortValue}
                    secondLevelRowDropdownValue={props.secondLevelRowDropdownValue.value}
                    paginationIconPrevious={
                      <ChevronLeft
                        color={props.defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                        onClick={() => {
                          props.prevSecondLevelHandler();
                        }}
                      />
                    }
                    paginationIconNext={
                      <ChevronRight
                        color={"rgba(0,0,0,0.54)"}
                        onClick={() => {
                          props.nextSecondLevelHandler();
                        }}
                      />
                    }
                    defaultSortField={props.defaultData.sortKeyUniqueImpExpMap[props.logisticsSortValue] ? props.defaultData.sortKeyUniqueImpExpMap[props.logisticsSortValue] : props.logisticsDefaultSortValue ? props.logisticsDefaultSortValue.columnKey : "date"}
                    shipmentDefaultSortValue={props.defaultData.logisticsSorting}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Logistics);
